import { useUserStore } from '../../../../modules/Auth/stores/authStore';

interface CircularProgressBarProps {
  percentage: number;
}

const CircularProgressBar = ({ percentage }: CircularProgressBarProps) => {
  const { user } = useUserStore();

  const progressOffset = ((100 - percentage) / 100) * 440;
  const isAbove50Percent = percentage >= 50 ? true : false;

  return (
    <svg
      className='mx-auto my-5 block h-[147px] w-[149px]'
      viewBox='0 0 150 152'
      fill={user?.isDarkMode ? '#FFFFFF' : '#000C29'}
      //@todo: ver como utilizar os design tokens
    >
      <circle
        className={`origin-center -rotate-90 transform ${
          isAbove50Percent
            ? 'stroke-feedback-color-success-lightest'
            : 'stroke-feedback-color-error-lightest'
        }`}
        r='70'
        cx='74.5'
        cy='73.5'
        fill='transparent'
        strokeWidth='10'
      />
      <circle
        className={`origin-center -rotate-90 transform ${
          isAbove50Percent
            ? 'stroke-feedback-color-success-darkest'
            : 'stroke-feedback-color-error-darkest'
        }`}
        r='70'
        cx='74.5'
        cy='73.5'
        fill='transparent'
        strokeWidth='10'
        strokeDasharray='440'
        strokeDashoffset={progressOffset}
        strokeLinecap='round'
      />
      <text x='50%' y='45%' dominantBaseline='middle' textAnchor='middle'>
        <tspan className='font-poppins text-lg font-bold'>{`${percentage.toFixed(
          1
        )}%`}</tspan>
        <tspan
          className='font-notoSans text-sm'
          dy='2em'
          x='50%'
          textAnchor='middle'
        >
          de aproveitamento
        </tspan>
      </text>
    </svg>
  );
};

export default CircularProgressBar;
